import React from 'react'
import { makeStyles, createStyles, Box, useTheme, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'
import ZoomImage from 'src/components/ZoomImage'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& img': {
        display: 'block',
        width: '100%',
      },
      marginBottom: 60,
      marginLeft: 8,
      marginRight: 8,
      maxWidth: 496,
    },
    mobile: {
      maxWidth: 375,
    },
  }),
)

const PaymentTutorial = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [tImage] = useImageTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  return (
    <Box className={classes.root} fontSize="body2.fontSize">
      <Box fontSize={isMobile ? 16 : 20} fontWeight={600} mt={isMobile ? 3 : 0} mb={2}>
        {t('glossary.promotion.PaymentTutorial.step0')}
      </Box>
      <ZoomImage
        srcThumbnail={tImage(isMobile ? 'promocode_mobile' : 'promocode_pc', 'webp')}
        src={tImage(isMobile ? 'promocode_mobile' : 'promocode_pc', 'webp')}
        alt="payment"
      />
      <Box fontSize={16} fontWeight={400} lineHeight="150%" mt={2}>
        {t('glossary.promotion.PaymentTutorial.step1')}
        <br />
        {t('glossary.promotion.PaymentTutorial.step2')}
        <br />
        {t('glossary.promotion.PaymentTutorial.step3')}
      </Box>
    </Box>
  )
}

export default PaymentTutorial
